import { useSelector } from 'react-redux';
import { ThemeButtonIcon } from '@shared/ui/buttons';
import { useNotificationsDrawer } from '@utils/drawer-hooks';
import { useThemeToggle } from '@utils/hooks/useThemeToggle';
import LogoutDisplay from '@widgets/user/LogoutDisplay';

export default function SidebarActions() {
  const { configs } = useSelector((state) => state.configs);
  const { toggleTheme } = useThemeToggle();
  const { count_unread } = useSelector((state) => state.notifications);

  const { openNotificationsDrawer } = useNotificationsDrawer();

  return (
    <div className="sidebar__actions">
      <ThemeButtonIcon
        icon="notification"
        onClick={openNotificationsDrawer}
        isNew={count_unread > 0}
      />
      <ThemeButtonIcon
        icon="send"
        as="a"
        href={configs.support_telegram}
        target="_blank"
      />
      <ThemeButtonIcon icon="dark-theme" onClick={toggleTheme} />
      <LogoutDisplay />
    </div>
  );
}
